<app-pcbread-crumb [data]="'Sale,SalePreInvoice'"></app-pcbread-crumb>

<div class="card p-2 animate__animated animate__backInDown">
  <app-pctable-action
    [data]="action"
    [header]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable-action>

  <app-pctable
    [data]="data"
    [entityField]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable>

  <app-pcpaging [paging]="paging" (parentAction)="parentAction($event)">
  </app-pcpaging>

  <app-loading-panel *ngIf="loading"> </app-loading-panel>
</div>

<app-pcsuccess-modal
  [showModal]="modalSuccessConfirm"
  (parentAction)="parentAction($event)"
>
</app-pcsuccess-modal>

<app-pcconfrim-modal
  *ngIf="modalDeleteConfirm"
  (childEvent)="parentAction($event)"
  [inputModel]="confirmModal"
></app-pcconfrim-modal>

<app-pcsetting-modal (parentAction)="parentAction($event)" [fields]="fields">
</app-pcsetting-modal>

<ng-template #InventoryDetails let-modal class="modal modal-top fade">
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "InventoryDetails" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close-modal btn-icon btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-body border-bottom">
    <div class="row">
      <div class="row p-1 m-0 drug-list" style="width: 100%">
        <div class="mvc-grid-table">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th scope="col">{{ "Row" | translate }}</th>
                <th scope="col">{{ "brandName" | translate }}</th>
                <th scope="col">{{ "companyName" | translate }}</th>
                <th scope="col">{{ "count" | translate }}</th>
                <th scope="col">{{ "stockName" | translate }}</th>
                <th scope="col">{{ "expireDate" | translate }}</th>
              </tr>
            </thead>
            <tbody id="rows">
              <tr *ngFor="let item of thisValue.inventoryDetails; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item.brandName }}</td>
                <td>{{ item.companyName }}</td>
                <td>{{ item.count }}</td>
                <td>{{ item.stockName }}</td>
                <td>{{ item.expireDate | dataType : "" : false }}</td>
                
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer justify-content-center p-2">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.dismiss('Cross click')"
    >
      <i class="bx bx-x"></i>
      {{ "Close" | translate }}
    </button>
  </div>
</ng-template>
